import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="text-white bg-gradient-to-b to-black from-gray-800 md:h-screen sm:h-fit px-4 pt-20"
    >
      <h1 className="py-2 text-4xl mb-8 font-bold inline border-b-4 border-gray-500">
        About
      </h1>
      <p className="mt-4 p-4 text-base  ">
        As a full stack developer with experience in the MERN stack (MongoDB,
        Express.js, React.js, Node.js), I am passionate about creating efficient
        and user-friendly web applications. During my internship, I had the
        opportunity to work on various projects that involved both front-end and
        back-end development. I have a strong foundation in JavaScript and have
        utilized React.js to build dynamic and interactive user interfaces. With
        React's component-based architecture and virtual DOM, I have been able
        to create scalable and maintainable front-end solutions. On the
        back-end, I have worked with Node.js and Express.js to build RESTful
        APIs that communicate with the database. I am familiar with database
        design and have experience working with MongoDB, a NoSQL database, to
        store and retrieve data efficiently. Throughout my internship, I have
        gained valuable experience in version control using Git and have
        collaborated with a team to deliver projects within tight deadlines. I am always
        eager to learn and stay updated with the latest technologies and trends
        in the web development industry. I am excited about the opportunities
        that lie ahead as a full stack developer and am committed to
        continuously improving my skills to contribute to the success of
        projects and deliver exceptional user experiences. Outside of work, I
        enjoy taking part in coding challenges and personal projects to further
        enhance my skills and knowledge.
      </p>
    </div>
  );
};

export default About;
